export default function formatToDecimal(number) {
  // Accept number or numeric string with commas, return USD string.
  // Show decimals up to 2 places only when necessary.
  const n = (typeof number === 'string')
    ? parseFloat(number.replace(/,/g, ''))
    : Number(number);

  if (!isFinite(n)) {
    return '$0';
  }

  const rounded = Math.round(n * 100) / 100;
  if (Number.isInteger(rounded)) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(rounded);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(rounded);
}
  